import { PropsWithChildren } from 'react';
import { useFeatureFlags } from '../../../services/featureFlags/hooks/useFeatureFlags';

export const DevOnlyFeature = ({ children }: PropsWithChildren) => {
  const { Developer } = useFeatureFlags();

  return Developer && children;
};
